import React from 'react';
import { css } from '@emotion/react';

import { DropdownOption } from './form/DropDown';
import theme from "../../theme";
import DropDown from "../components/form/DropDown";

type Props = {
    currentPlanType: DropdownOption,
    onChange: Function,
    options: Array<DropdownOption>,
    selected: DropdownOption
};

const PlanSelectionUsers: React.FC<Props> = ({
    currentPlanType,
    onChange,
    options,
    selected,
}) => (
    <div css={containerStyle(currentPlanType.id === 'personal')}>
        { currentPlanType.id === 'family' && (
            <>
                <div css={dropdownStyle}>
                    <DropDown
                        extraChevronStyles={extraChevronStyles}
                        extraOptionContainerStyles={extraOptionContainerStyles}
                        extraOptionStyles={extraOptionStyles}
                        hasBorder={false}
                        options={options}
                        searchable={false}
                        selected={selected}
                        setSelected={onChange}
                        extraSelectedStyles={extraSelectedStyles}
                        css={dropdownContainerStyle}
                    />
                </div>
                Users
            </>
        )}
        { currentPlanType.id === 'personal' && (
            <div css={singleUserStyle}>1 User</div>
        )}
    </div>
);

const containerStyle = (isPersonal: boolean) => css`
    padding-left: 10px;
    width: 150px;
    height: 32px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: ${theme.fonts.weights.base};

    ${isPersonal && css`
        ${theme.breakpoints.down('xs')} {
            width: 120px;
            text-align: right;
        }
    `}
`;

const dropdownStyle = css`
    cursor: pointer;
    width: 70px;
    height: 32px;
    margin-right: 10px;
    background-color: white;
    border-radius: 8px;
    text-align: center;
    z-index: 5;
    padding: 0 5px 0 10px;
    display: flex;
    align-items: center;

    ${theme.breakpoints.down('xs')} {
        margin-right: 5px;
    }
`;

const dropdownContainerStyle = css`
    border-radius: 8px;
`;

const singleUserStyle = css`
    text-align: right;
    width: 113px;

    ${theme.breakpoints.down('xs')} {
        width: 100%;
        padding-right: 10px;
    }
`;

const extraChevronStyles = css`
    right: 0;
`;

const extraOptionContainerStyles = css`
    width: 70px;
    top: 32px;
    left: -10px;
    height: 180px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
`;

const extraOptionStyles = css`
    height: inherit;
    padding: 5px 5px 5px 21px;

    p {
        font-size: 16px;
    }
`;

const extraSelectedStyles = css`
    padding-left: 10px;
`;

export default PlanSelectionUsers;
